import { render, staticRenderFns } from "./LoginSms1.vue?vue&type=template&id=23839337&scoped=true&"
import script from "./LoginSms1.vue?vue&type=script&lang=js&"
export * from "./LoginSms1.vue?vue&type=script&lang=js&"
import style0 from "./LoginSms1.vue?vue&type=style&index=0&id=23839337&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23839337",
  null
  
)

component.options.__file = "LoginSms1.vue"
export default component.exports